import script from "./itemModelpage.vue?vue&type=script&setup=true&lang=js"
export * from "./itemModelpage.vue?vue&type=script&setup=true&lang=js"

import "./itemModelpage.vue?vue&type=style&index=0&id=0c5fc06b&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5fc06b"]])

export default __exports__